/* The display timer is independent of cart pricing and inventory. */
(() => {
  if (window.ClarivaneOfferCountdownInitialized) return;
  window.ClarivaneOfferCountdownInitialized = true;

  function start(node) {
    if (node.dataset.timerInitialized) return;
    node.dataset.timerInitialized = "true";
    const output = node.querySelector(".clarivane-offer-countdown__time");
    if (!output) return;

    let deadline;
    let durationMs;
    let storageKey;
    if (node.dataset.mode === "fixed") {
      if (!node.dataset.end) { node.hidden = true; return; }
      deadline = Date.parse(node.dataset.end);
    } else {
      const hours = Math.max(1, Math.min(48, Number(node.dataset.hours) || 10));
      durationMs = hours * 60 * 60 * 1000;
      storageKey = "clarivane-offer-timer:" + node.dataset.key + ":" + hours;
      try {
        deadline = Number(localStorage.getItem(storageKey));
        if (!Number.isFinite(deadline) || deadline <= 0) {
          deadline = Date.now() + durationMs;
          localStorage.setItem(storageKey, String(deadline));
        }
      } catch (_) {
        deadline = Date.now() + durationMs;
      }
    }
    if (!Number.isFinite(deadline)) { node.hidden = true; return; }

    let timer;
    function render() {
      const now = Date.now();
      if (durationMs && now >= deadline) {
        const elapsedCycles = Math.floor((now - deadline) / durationMs) + 1;
        deadline += elapsedCycles * durationMs;
        try { localStorage.setItem(storageKey, String(deadline)); } catch (_) {}
      }
      const seconds = Math.max(0, Math.ceil((deadline - now) / 1000));
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainder = seconds % 60;
      output.textContent = [hours, minutes, remainder].map(n => String(n).padStart(2, "0")).join(":");
      if (seconds === 0 && timer) clearInterval(timer);
    }
    render();
    timer = setInterval(render, 1000);
  }

  function initialize(root = document) {
    root.querySelectorAll("[data-offer-countdown]").forEach(start);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener("shopify:section:load", event => initialize(event.target));
})();
